import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ConfigProvider } from "antd";
import { suppressResizeObserverLoopError } from "./utils/echartsResizeObserver";

suppressResizeObserverLoopError();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ConfigProvider
    theme={{
      token: {
        // Brand
        colorPrimary: "#1677ff",
        // Semantic status — IoT palette
        colorSuccess: "#10b981",   // emerald — "online / healthy"
        colorWarning: "#f59e0b",   // amber   — "warning / degraded"
        colorError: "#ef4444",     // rose    — "offline / critical"
        colorInfo: "#1677ff",
        // Layout canvas
        colorBgLayout: "#f0f5ff",  // very-light blue-tinted canvas
        colorBgContainer: "#ffffff",
        // Typography
        colorTextBase: "#0f172a",
        colorTextSecondary: "#64748b",
        // Borders
        colorBorder: "#dce8fb",
        colorBorderSecondary: "#eef3fc",
        // Radius
        borderRadius: 8,
        borderRadiusLG: 12,
        borderRadiusSM: 4,
        // Shadows
        boxShadow: "0 1px 3px rgba(15,23,42,0.08)",
        boxShadowSecondary: "0 1px 2px rgba(15,23,42,0.04)",
      },
    }}
  >
    <App />
  </ConfigProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
